import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const ActionComponent = React.lazy(() => import("../Components/RootComponents/ActionComponent"));
const ActionPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <ActionComponent />
      </Suspense>
    </Fragment>
  );
};

export default ActionPage;
